export interface ClientInsuranceInterface {
  id: number;
  asOfDate?: string;
  groupNumber?: string;
  insuranceType: string;
  planYear?: string;
  policyHolder?: string;
  policyNumber?: string;
  untilDate?: string;
  createdAt: string;
  updatedAt: string;
  clientId: number;
  payerId: number;
}

export class ClientInsurance implements ClientInsuranceInterface {
  id: number;
  asOfDate?: string;
  groupNumber?: string;
  insuranceType: string;
  planYear?: string;
  policyHolder?: string;
  policyNumber?: string;
  untilDate?: string;
  createdAt: string;
  updatedAt: string;
  clientId: number;
  payerId: number;

  constructor(data: Partial<ClientInsuranceInterface>) {
    this.id = data.id!;
    this.asOfDate = data.asOfDate;
    this.groupNumber = data.groupNumber;
    this.insuranceType = data.insuranceType!;
    this.planYear = data.planYear;
    this.policyHolder = data.policyHolder;
    this.policyNumber = data.policyNumber;
    this.untilDate = data.untilDate;
    this.createdAt = data.createdAt!;
    this.updatedAt = data.updatedAt!;
    this.clientId = data.clientId!;
    this.payerId = data.payerId!;
  }

  toJson(): ClientInsuranceInterface {
    return {
      id: this.id,
      asOfDate: this.asOfDate,
      groupNumber: this.groupNumber,
      insuranceType: this.insuranceType,
      planYear: this.planYear,
      policyHolder: this.policyHolder,
      policyNumber: this.policyNumber,
      untilDate: this.untilDate,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      clientId: this.clientId,
      payerId: this.payerId,
    };
  }
}
